const html = require('choo/html')

module.exports = function InputText (args) {
  const {
    label,
    value,
    placeholder,
    disabled = false,
    greyedOut = false,
    onFocus = () => false,
    onBlur = () => false,
    onChange = () => false,
    onKeyUp = null,
    onKeyDown = null,
    onInput = () => false,
    onClick = () => false
  } = args
  let disabledClass = ''
  if (disabled) {
    disabledClass = 'disabled'
  } else if (greyedOut) {
    disabledClass = 'greyedOut'
  }
  const w = 30
  const values = value.split(':')
  function timeInput (i, e) {
    //    e.target.value = 10

    const newValues = [...values]
    newValues[i] = e.target.value
    for (let n = 0; n < 3; n++) {
      let v = newValues[n]
      v = Math.max(0, v)
      v = Math.min(59, v)
      v = (v).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false})
      newValues[n] = v
    }
    const valString = `${newValues[0]}:${newValues[1]}:${newValues[2]}`
    const tmp = { target: { value: valString } }
    onInput(tmp)
  }
  return html`
    <div class="input input-text ${disabledClass}">
      <label style = "display:block;">${label}</label>
      <input
      style="margin-right:5%; display: inline; width:${w}%;"
      class="input-area"
        type="number"
        value="${values[0]}"
        placeholder=${placeholder}
        disabled="${disabled}"
        onfocus=${onFocus}
        onblur=${onBlur}
        onchange=${onChange}
        onkeyup=${onKeyUp}
        onkeydown=${onKeyDown}
        oninput=${e => {
    timeInput(0, e)
  }}
        onclick=${onClick}
        />
        <input
        style="margin-right:5%; display: inline; width:${w}%;"
        class="input-area"
        type="number"
        value="${values[1]}"
        placeholder=${placeholder}
        disabled="${disabled}"
        onfocus=${onFocus}
        onblur=${onBlur}
        onchange=${onChange}
        onkeyup=${onKeyUp}
        onkeydown=${onKeyDown}
        oninput=${e => {
    timeInput(1, e)
  }}
        onclick=${onClick}
        />
        <input
        style="display: inline; width:${w}%;"
        class="input-area"
        type="number"
        value="${values[2]}"
        placeholder=${placeholder}
        disabled="${disabled}"
        onfocus=${onFocus}
        onblur=${onBlur}
        onchange=${onChange}
        onkeyup=${onKeyUp}
        onkeydown=${onKeyDown}
        oninput=${e => {
    timeInput(2, e)
  }}
        onclick=${onClick}
        />
    </div>
  `
}
